import React from "react";
import TiendaArticulos from "./components/TiendaArticulos/TiendaArticulos";
import { TiendaBody, TiendaBox, TiendaFooter, TiendaHeader, TiendaLogo, } from "./TiendaStyled";
var Tienda = function (_a) {
    var tienda = _a.tienda, viewContext = _a.viewContext;
    return (React.createElement(TiendaBox, null,
        React.createElement(TiendaHeader, { viewContext: viewContext, relevancia: tienda.relevancia, style: { backgroundImage: "url(\"".concat(tienda.tienda_header_mini, "\")") } },
            React.createElement(TiendaLogo, { viewContext: viewContext, relevancia: tienda.relevancia, alt: tienda.titulo, title: tienda.titulo, src: tienda.fab_imagen })),
        React.createElement(TiendaBody, null,
            viewContext !== "home" && tienda.relevancia === 1 && (React.createElement("h2", null, tienda.titulo)),
            viewContext !== "home" && tienda.relevancia === 1 && (React.createElement("p", null, tienda.descripcion)),
            React.createElement(TiendaArticulos, { viewContext: viewContext, relevancia: tienda.relevancia, articulos: viewContext !== "home"
                    ? tienda.productos
                    : tienda.productos.slice(0, 4) })),
        React.createElement(TiendaFooter, null,
            React.createElement("a", { href: "tienda/" + tienda.url_seo }, "Visitar"))));
};
export default Tienda;
